import usePlaylist from './usePlaylist';
import type { GetPlaylistParams } from '@jwp/ott-common/types/playlist';

export default function usePlaylistFirstItem(
  playlistId?: string,
  params: GetPlaylistParams = {},
  enabled = true,
  usePlaceholderData = false,
) {
  const query = usePlaylist(
    playlistId,
    params,
    enabled,
    usePlaceholderData,
  );

  const playlistItem = query.data?.playlist?.find(
    (item) => item.mediaid === params.mediaId,
  );

  return {
    ...query,
    data: playlistItem,
  };
}
